import { useEffect, useState } from 'react'

const breakpoints = {
  sm: '(min-width: 640px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 1024px)',
  xl: '(min-width: 1280px)',
  '2xl': '(min-width: 1536px)'
}

export function useIsMobile(maxBreakpoint: keyof typeof breakpoints = 'lg') {
  const [isMobile, setIsMobile] = useState<boolean>(false)

  useEffect(() => {
    const query = window.matchMedia(
      `(max-width: ${parseInt(breakpoints[maxBreakpoint].match(/\d+/)?.[0] || '1024') - 1}px)`
    )

    const update = () => setIsMobile(query.matches)
    update()

    query.addEventListener('change', update)
    return () => query.removeEventListener('change', update)
  }, [maxBreakpoint])

  return isMobile
}
